import { action } from 'sky-engine/api/index'

import { PLAN_MNG, DELIVERY_PLAN_MNG } from '@/api/apiModules'
/**
 * 获取外设信息
 * @param {*} data
 * @returns
 */
export function getPlanTopology(data) {
  return action(PLAN_MNG, 'getPlanTopology', data)
}

/**
 * 获取外设信息
 * @param {*} data
 * @returns
 */
export function savePlanTopology(data) {
  return action(PLAN_MNG, 'savePlanTopology', data)
}

/**
 * 获取测试方案是否生成
 * @param {*} data
 * @returns
 */
export function getInstPlan(data) {
  return action(PLAN_MNG, 'getInstPlan', data)
}

/**
 * 获取测试方案
 * @param {*} data
 * @returns
 */
export function download(data) {
  return action(PLAN_MNG, 'download', data)
}

/**
 * 获取交付方案是否生成
 * @param {*} data
 * @returns
 */
export function getInstDeliveryPlan(data) {
  return action(DELIVERY_PLAN_MNG, 'getInstPlan', data)
}

/**
 * 获取交付方案
 * @param {*} data
 * @returns
 */
export function downloadDelivery(data) {
  return action(DELIVERY_PLAN_MNG, 'download', data)
}

/**
 * 生成交付方案
 * @param {*} data
 * @returns
 */
export function generateDeliveryPlan(data) {
  return action(DELIVERY_PLAN_MNG, 'generatePlan', data)
}
